import React, { Fragment, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import cn from 'classnames';
import NotificationSystem from 'react-notification-system';

import Header from 'components/Header';
import FormGroup from 'components/Form/FormGroup';
import FormGroupLabel from 'components/FormGroupLabel';
import { Grid, Column } from 'components/Layout';
import Input from 'components/Form/Input';
import Validator from 'components/Validator/Validator';
import { Button } from 'components/Button';

import { awsLoginRequest } from 'utils/aws';

import schema from './setNewPasswordSchema';
import style from './style.scss';

const SetNewPassword = (props) => {
  const { validator: { values, errors } } = props;
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const notification = useRef(null);

  const handleInputChange = (event) => {
    const { validator: { onChangeHandler } } = props;
    onChangeHandler(event.target.name, event.target.value);
  };

  const handleSubmitFrom = (data, e) => {
    e.preventDefault();
    const { validator: { validate }, history } = props;

    if (validate(schema).isValid) {
      const userCred = {
        payload: {
          username: localStorage.getItem('user.username').trim(),
          password: values.temporaryPassword.trim(),
        },
      };

      const attributesData = {
        // email: localStorage.getItem('user.username'),
        // 'custom:first_name': values.firstname,
        // 'custom:last_name': values.lastname,
      };
      setIsLoading(true);
      awsLoginRequest(userCred).then((res) => {
        if (res.error === 'New password required') {
          res.cognitoUser.completeNewPasswordChallenge(values.password, attributesData, {
            onSuccess: (result) => { // eslint-disable-line
              setIsLoading(false);
              history.replace('/');
            },
            onFailure: (error) => { // eslint-disable-line
              setIsLoading(false);
              setError(error.message);
            },
          });
        }
      }).catch((err) => {
        setIsLoading(false);
        setError(err.message);
      });
    }
  };

  return (
    <Fragment>
      <NotificationSystem ref={notification} />
      <Header />
      <section className={cn('grid-container fluid borrowers-apply section', style.loginContainer)}>
        {error && (<label className="error">{error}</label>)}
        <div className={cn('grid-container', style.innerLogin)}>
          <Grid className="grid-margin-x max-limited">
            <Column className="small-12 large-12 main-column">
              <FormGroup className="form-group">
                <form onSubmit={handleSubmitFrom}>
                  <Grid className="grid-margin-x">
                    <Column className="small-12 medium-10 medium-offset-1">
                      <FormGroupLabel value="Set New Password" />
                      <Grid className="grid-margin-x">
                        <Column className="small-12 medium-12">
                          <Input
                            name="temporaryPassword"
                            type="password"
                            label="Temporary Password"
                            value={values.temporaryPassword}
                            onChange={handleInputChange}
                            hasError={!!errors.temporaryPassword}
                            hasValue
                            placeHolder="Temporary Password"
                            isBadgeVisible={false}
                            isRequired
                          />
                        </Column>
                        <Column className="small-12 medium-12">
                          <Input
                            name="password"
                            type="password"
                            label="New Password"
                            value={values.password}
                            onChange={handleInputChange}
                            hasError={!!errors.password}
                            hasValue
                            placeHolder="New Password"
                            isBadgeVisible={false}
                            isRequired
                          />
                        </Column>
                        <Column className="small-12 medium-12">
                          <Input
                            name="confirmPassword"
                            type="password"
                            label="Confirm Password"
                            value={values.confirmPassword}
                            onChange={handleInputChange}
                            hasError={!!errors.confirmPassword}
                            hasValue
                            placeHolder="Confirm Password"
                            isBadgeVisible={false}
                            isRequired
                          />
                        </Column>
                        <Column className="small-12 medium-12">
                          <Button
                            className={cn('button small green w-100', style.button)}
                            onClick={handleSubmitFrom.bind(null, values)}
                            isLoading={isLoading}
                          >
                            Login
                          </Button>

                        </Column>
                      </Grid>
                    </Column>
                  </Grid>
                </form>
              </FormGroup>
            </Column>
          </Grid>
        </div>
      </section>
    </Fragment>
  );
};

SetNewPassword.propTypes = {
  validator: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default compose(
  withRouter,
  Validator(schema)
)(SetNewPassword);



// WEBPACK FOOTER //
// ./src/containers/pages/Auth/SetNewPassword.js